import React from "react";

export const ProductGallery = ({ product, color }) => {
  const colorOverride = product.color_images?.[color];
  const mainSrc = colorOverride?.image || product.image;
  const mainPos = colorOverride?.position || product.image_position || "center";

  return (
    <div className="col-span-12 lg:col-span-7 grid grid-cols-1 gap-4 fade-up">
      <div className="aspect-[4/5] bg-[#efe6db] overflow-hidden">
        <img
          src={mainSrc}
          alt={`${product.name} — ${color}`}
          className="w-full h-full object-cover transition-opacity duration-500"
          style={{ objectPosition: mainPos }}
          key={`${mainSrc}-${color}`}
          data-testid="product-main-image"
        />
      </div>
      {product.gallery?.slice(1).map((g, i) => (
        <div key={g} className="aspect-[4/5] bg-[#efe6db] overflow-hidden">
          <img src={g} alt={`${product.name} look ${i + 2}`} className="w-full h-full object-cover" />
        </div>
      ))}
    </div>
  );
};
